import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "spark" }
const _hoisted_2 = { class: "container-default max-w-4xl space-y-6" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" The Spark for ")
const _hoisted_5 = { class: "space-y-2" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" NFT collections displaying one human base avatar with various shades of skin colors and calling it diverse is something that ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" wants to do better. Therefore, the inclusion of five diverse ethnic backgrounds shows actual relatable individual human characters. ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" uses a concept of five human character avatars that cherishes each individual's uniqueness while still being able to assign all wearable traits. A concept that highlights everyone's diverse appearance while also showcasing what connects us. ")

import AppCta from "@/components/app/AppCta.vue";
import TextCenteredSection from "@/components/section/TextCenteredSection.vue";
import DripversityIcon from "@/components/icons/DripversityIcon.vue";
import DripversityDvIcon from "@/components/icons/DripversityDvIcon.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeAbout',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("h2", _hoisted_3, [
          _hoisted_4,
          _createVNode(DripversityIcon, { class: "text-dripversity w-64 pb-3" })
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("p", null, [
          _hoisted_6,
          _createVNode(DripversityIcon, { class: "text-dripversity" }),
          _hoisted_7
        ]),
        _createElementVNode("p", null, [
          _createVNode(DripversityIcon, { class: "text-dripversity" }),
          _hoisted_8
        ])
      ]),
      _createElementVNode("div", null, [
        _createVNode(AppCta)
      ])
    ])
  ]))
}
}

})